import { MappingShippingRate } from 'features/shipping-provider/settings/models/shipping-rate-mapping';
import { useTranslation } from 'react-i18next';

/** One shipping-type group's (home delivery vs. pickup points) mapped rates. */
export const MappedShippingTypeGroupRates: React.FC<{ labelKey: string; shippingRates: MappingShippingRate[] }> = ({
    labelKey,
    shippingRates,
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-wrap items-center gap-1">
            <s-text color="subdued">{t(labelKey as any)}:</s-text>
            {shippingRates.length > 0 ? (
                shippingRates.map((rate) => <s-badge key={rate.id}>{rate.name || rate.id}</s-badge>)
            ) : (
                <s-text color="subdued">
                    {t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.NO_RATES_FOR_SHIPPING_TYPE')}
                </s-text>
            )}
        </div>
    );
};

export default MappedShippingTypeGroupRates;
